<template>
	<div>
		<div
			class="modal fade"
			id="addclient"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">{{this.type=='edit'?'Edit Client':'Add Client'}}</h5>
						<button type="button" class="close" data-dismiss="modal" @click="cancel">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="modal-body" style="margin-top:25px">
						<div class="spinner-border" v-if="showLoader" style="margin:auto;display:block"/>
						<div v-else>
							<div class="form-group row">
								<label class="col-sm-3 col-form-label">
									Client Name
									<sup>*</sup>
								</label>
								 <div class="col-sm-7">
									 <div class="form-check d-inline-block" style="display:flex !important">
										 <input
										   type="text"
										   name="newClient"
										   v-model="clientName"
										   class="form-control"
										   id="newClient"
										   placeholder="Client name"
										   autocomplete = "off"
										   min="0"
										   onkeypress="return event.charCode != 45"
										   @click="duplicateName = false;invalidName = false"
									   >
									 </div>
									 <p v-if="invalidName" class="ml-4 mt-1 no-data-style">Please enter a name.</p>
									 <p v-else-if="duplicateName" class="ml-4 mt-1 no-data-style">Client with similar details already exist.</p>
								 </div>
							</div>
							<div class="form-group row">
								<label class="col-sm-3 col-form-label">
									go_client_cd
									<sup>*</sup>
								</label>
								 <div class="col-sm-7">
									 <div class="form-check d-inline-block" style="display:flex !important">
										 <input
										   type="text"
										   name="go_client_cd"
										   v-model="go_client_cd"
										   class="form-control"
										   id="newClient"
										   placeholder="go_client_cd"
										   autocomplete = "off"
										   min="0"
										   onkeypress="return event.charCode != 45"
										   disabled = true
									   >
									 </div>
								 </div>
							</div>
						</div>
				    </div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="cancel">Cancel</button>
							<button type="button" class="btn btn-primary"  @click = "saveNewClient">Save</button>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

import md5 from 'js-md5'


export default {
	name: "AddNewClientPopUp",
	props:["newClientName",'type','clientId','oldClientCd'],
	components:{md5},
	data(){
		return{
			go_client_cd:'',
			showLoader:false,
			duplicateName: false,
			invalidName:false,
			clientName:''
		}
	},
	mounted(){
		this.newClientName = this.clientName
	},
	watch:{
		clientName(){
			this.go_client_cd = this.clientId ? this.oldClientCd : md5(this.clientName)
		},
		newClientName(){
			this.clientName = this.newClientName
		}
	},
	methods:{
		cancel(){
			this.clientName = ''
			this.duplicateName = false
			this.invalidName = false
			this.$emit('closeSaveClient','cancel')
		},
		saveNewClient(){
			if(!this.clientName.trim()){
				this.invalidName = true
				return
			}
			this.invalidName = false
			if(this.type=='edit' && this.clientId){
				var payload = {
					id:this.clientId,
					client_name:this.clientName,
					go_client_cd:this.go_client_cd
				}
			}
			else{
				var payload = {
					client_name:this.clientName,
					go_client_cd:this.go_client_cd
				}
			}
			this.duplicateName = false
			this.showLoader = true;
			let vm = this;
			this.$store.dispatch('accounts/saveNewClientData',payload).then((res) => {
				vm.showLoader = false
				if(res == "client Name already Exist"){
					vm.duplicateName = true
					// vm.clientName = ''
					return
				}
				vm.$emit('newClientInfo', res)
				vm.$emit('closeSaveClient','close')
			})
		}
	}
}

</script>
